import { BaseEntity, DefaultResponseWithData } from "./system";

export interface IVehiclePackageData extends BaseEntity {
  modelDetailsFetchedAt?: Date | null;
  rawModelDetailsJson: string;

  vehicleDetailsFetchedAt?: Date | null;
  rawVehicleDetailsJson: string;

  motDetailsFetchedAt?: Date | null;
  rawMotDetailsJson: string;

  tyreDetailsFetchedAt?: Date | null;
  rawTyreDetailsJson: string;

  valuationDetailsFetchedAt?: Date | null;
  rawValuationDetailsJson: string;

  imageDetailsFetchedAt?: Date | null;
  rawImageDetailsJson: string;
}

export interface IVehiclePackageResponse
  extends DefaultResponseWithData<IVehiclePackageData> { }
  
export enum VehiclePackage
{
  WidgetData,
  JustSalvage, // Valuation Details
  JustVehicle, // Model Details and Vehicle Details
  JustMot,     // MOT Details
  JustTyres,   // Tyre Details
  JustImages,  // Image Details
  GroupedData  // All of it (what the system used to use)
}